import React, { useState, useEffect, useContext } from "react";
// import axios from "axios";
import MUIDataTable from "mui-datatables";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import LoaderComponent from "../components/admin/LoaderComponent";
import {
  Box,
  Modal,
  TextField,
  MenuItem,
  Autocomplete,
  IconButton,
  // Card,
  // CardContent,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import Dialog from "@mui/material/Dialog/Dialog";
// import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
// import DialogContent from "@mui/material/DialogContent/DialogContent";
// import DialogActions from "@mui/material/DialogActions/DialogActions";
import { services } from "../services/api";
import { NotificacionContext } from "../context/notificacion_context";
import Tooltip from "@mui/material/Tooltip";
import IconUI from "../components/iu/icon_ui";
import { 
  AiOutlineEdit, 
  AiOutlineDelete, 
  // AiFillSignature, 
  AiOutlineFolderOpen
} from "react-icons/ai";
// import { AiFillSignature } from "react-icons/ai";

// import { FaUserPen } from "react-icons/fa6";
import dayjs from "dayjs";
import { FaHandsHelping, FaFileSignature } from "react-icons/fa";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment/moment";
import { maxLengthLimitInput, onlyNumber } from "../utils/inputsRules";
import { formatAuthorityCrimes } from "../utils/formatAuthorityCrimes";
import { GlobalContext } from "../context/global_context";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ModalText from "../components/ModalText";
// import SearchIcon from "@mui/icons-material/Search";
// import { RiFileExcel2Line } from "react-icons/ri";
// import PriorityHigh from "@mui/icons-material/PriorityHigh";

const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTable: {
        styleOverrides: {
          root: {
            borderRadius: "30px !important",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: "#3c6218 !important",

            color: "white",
          },
        },
      },
    },
  });

const SolicitudesVictimasView = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    maxWidth: "90vw",
    maxHeight: "90vh",
    bgcolor: "background.paper",
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    overflowX: "hidden",
    borderRadius: "40px",
    scrollbarWidth: "thin",
    scrollbarColor: "#661d40 #f1f1f1",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#661d40",
      borderRadius: "10px",
    },
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",

    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const style3 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",

    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    width: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: "#661d40",

    "&:hover": {
      backgroundColor: "#661d40",

    },
    borderRadius: "40px",
  }));

  const goTo = useNavigate();

  const location = useLocation();
  const routeParams = useParams();
  const searchParams = new URLSearchParams(location.search);
  const { victimId } = useParams();
  const status_group = routeParams.status_group ?? searchParams.get("status_group");
  const applicationId = routeParams.applicationId ?? searchParams.get("applicationId");

  const { setPeticion } = useContext(GlobalContext);
  const [state, setState] = useState({
    citizens: [],
    requests: [],
    ciudadano: [],
    tiposPeticion: [],
    areas: [],
    municipios: [],
    localidades: [],
    citizenSelected: "",
    dateSelected: "",
    fontSelected: "",
    numTour: "",
    nameTour: "",
    observations: "",
    fonts: [],

    documents: {},
    openDescripcion: false,
    descripcion: "",
    openEditarCiudadano: false,

    citizenEditSelected: {},
    openFiltro: false,
    openPreviewDocumento: false,
    previewDocumentoUrl: "",
    previewDocumentoNombre: "",
    previewDocumentoMime: "",
  });

  const openModalDescripcion = (descripcion) => {
    setState((prev) => ({
      ...prev,
      openDescripcion: true,
      descripcion,
    }));
  };

  const handleCloseDescripcion = () => {
    setState((prev) => ({ ...prev, openDescripcion: false }));
  };

  const [buscador, setBuscador] = useState({
    texto: "",
    error: "",
  });

  // const [exportarBandera, setExportarBandera] = useState(1);

  // const [titulosState, setTitulos] = useState({
  //   data: [],
  // });
  // const [cargosState, setCargos] = useState({
  //   data: [],
  // });

  const [formularioState, setFormulario] = useState({
    ciudadano_id: "",
    observaciones: "",
    fuente_solicitud_id: "",
    fecha_audiencia: "",
    numero_gira: "",
    lugar_gira: "",
  });

  const [formularioPeticionState, setFormularioPeticion] = useState({
    // tipo_peticion_id: "",
    subject: "",
    priority: "",
    area_id: "",
    // atencion_inmediata: true,
  });

  const [filtroSolicitud, setFiltroSolicitud] = useState({
    cantidad: 10,
    folio: "",
    ciudadano: "",
    fecha: null,
    estado: "",
    fuente_solicitud: "",
    numero_gira: "",
    lugar_gira: "",
  });

  const [loader, setLoader] = useState({
    loading: false,
  });
  
  const formatDisplayDate = (value) => {
    if (!value) return "-";
    return moment.utc(value).local().format("DD-MM-YYYY");
  };

  const uppercaseText = (value) =>
    typeof value === "string" ? value.toUpperCase() : value;

  const normalizeValue = (value) =>
    value?.toUpperCase().replace(/[_\s]/g, "") || "";
  
  const isRegistro = normalizeValue(localStorage.getItem("area_type")) === "REGISTRO";
  const isPrimerContacto = normalizeValue(localStorage.getItem("area_type")) === "PRIMERCONTACTO";
  const tiposDocumentosPermitidos = isPrimerContacto
      ? ["FUD", "DENUNCIA"]
      : ["FUD", "DENUNCIA", "REVIM", "DICTAMEN_ECONOMICO"];
  // const handleFileChange = (tipo, event) => {
  //   const file = event.target.files[0];

  //   if (!file) return;

  //   setState((prev) => ({
  //     ...prev,
  //     documents: {
  //       ...prev.documents,
  //       [tipo]: {
  //         file,
  //         preview: URL.createObjectURL(file),
  //       },
  //     },
  //   }));
  // };
  const validarArchivoPdf = (file) => {
    if (!file) return false;

    const isPdf = file.type === "application/pdf" || file.name?.toLowerCase().endsWith(".pdf");
    const isValidSize = file.size <= 5 * 1024 * 1024;

    if (!isPdf) {
      showNotification(
        "error",
        "Archivo no permitido",
        "Solo se permiten archivos PDF.",
        null,
        4,
      );
      return false;
    }

    if (!isValidSize) {
      showNotification(
        "error",
        "Archivo muy pesado",
        "El archivo debe pesar menos de 5 MB.",
        null,
        4,
      );
      return false;
    }

    return true;
  };

  const handleFileChange = (tipo, e) => {
    const file = e.target.files[0];

    if (!file) return;
    if (!validarArchivoPdf(file)) {
      e.target.value = "";
      return;
    }

    const preview = URL.createObjectURL(file);

    setState((prev) => ({
      ...prev,
      documents: {
        ...prev.documents,
        [tipo]: {
          file,
          preview,
          existing: false,
        },
      },
    }));
  };
  const handleFiltroFolio = (e) => {
    setFiltroSolicitud({ ...filtroSolicitud, folio: e.target.value });
  };
  const handleFiltroCiudadano = (e) => {
    setFiltroSolicitud({ ...filtroSolicitud, ciudadano: e.target.value });
  };
  const handleFiltroEstado = (e) => {
    setFiltroSolicitud({ ...filtroSolicitud, estado: e.target.value });
  };
  const handleFiltroFecha = (e) => {
    const selectedDate = dayjs(e.$d);
    setFiltroSolicitud({
      ...filtroSolicitud,
      fecha: selectedDate.format("YYYY-MM-DD"),
    });
  };
  const handleFiltroFuente = (e) => {

    setFiltroSolicitud({
      ...filtroSolicitud,
      fuente_solicitud: e.target.value,
    });
  };
  const handleFiltroNumero = (e) => {
    setFiltroSolicitud({ ...filtroSolicitud, numero_gira: e.target.value });
  };
  const handleFiltroLugar = (e) => {
    setFiltroSolicitud({ ...filtroSolicitud, lugar_gira: e.target.value });
  };

  const limpiarFiltros = () => {
    setFiltroSolicitud({
      ...filtroSolicitud,
      folio: "",
      ciudadano: "",
      fecha: null,
      estado: "",
      fuente_solicitud: "",
      numero_gira: "",
      lugar_gira: "",
    });
  };

  const [openModal, setopenModal] = useState(false);
  const [openModalPeticion, setOpenModalPeticion] = useState(false);
  const [openModalEditar, setOpenModalEditar] = useState(false);
  const [openModalEliminarState, setOpenModalEliminar] = useState(false);
  const [openModalAdjuntos, setOpenModalAdjuntos] = useState(false);

  const { showNotification } = useContext(NotificacionContext);

  const cerrarPreviewDocumento = () => {
    setState((prev) => ({
      ...prev,
      openPreviewDocumento: false,
      previewDocumentoUrl: "",
      previewDocumentoNombre: "",
      previewDocumentoMime: "",
    }));
  };

  const abrirVistaPreviaDocumento = (documento) => {
    if (!documento) return;

    const url = documento.existing ? documento.url : documento.preview;
    const mimeType = documento.file?.type || documento.mimeType || "application/pdf";
    const nombre = documento.original_name || documento.file?.name || "documento";

    if (!url) return;

    setState((prev) => ({
      ...prev,
      openPreviewDocumento: true,
      previewDocumentoUrl: url,
      previewDocumentoNombre: nombre,
      previewDocumentoMime: mimeType,
    }));
  };

  const [errors, setErrors] = useState({});

  const enviarArchivos = async () => {
    setLoader((prev) => ({ ...prev, loading: true }));

    try {
      const formData = new FormData();

      const documentsArray = Object.entries(state.documents)
      .filter(([_, value]) => {
        return value && value.file;
      })
      .map(([type, value]) => ({
        type,
        file: value.file,
      }));

      if (!documentsArray.length) {
        showNotification(
          "error",
          "Sin archivos",
          "Debes seleccionar al menos un archivo PDF.",
          null,
          4,
        );
        return;
      }

      const invalidDocuments = documentsArray.filter((doc) => !validarArchivoPdf(doc.file));
      if (invalidDocuments.length > 0) {
        return;
      }

      documentsArray.forEach((doc, index) => {
        formData.append(
          `documents[${index}][type]`,
          doc.type
        );

        formData.append(
          `documents[${index}][file]`,
          doc.file
        );
      });

      const response = await services({
        method: "POST",
        service: `applications/${state.citizenEditSelected.id}/documents`,
        body: formData,
      });

      if (response.status === 200) {
        showNotification("success", "Documentos", "Cargados con Éxito", null, 4);
        setOpenModalAdjuntos(false);
      } else {
        showNotification(
          "error",
          "Ups... Algo sucedió",
          "Error al cargar los documentos",
          null,
          4,
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader((prev) => ({ ...prev, loading: false }));
    }
  };

  const eliminarDocumento = async (tipo) => {

    const documento = state.documents[tipo];

    if (!documento) return;

    try {

      // Si ya existe en BD
      if (documento.existing) {
        const eliminar = await services({
          method: "DELETE",
          service: `documents/${documento.id}`,
          body: null,
        });
      
        if(eliminar.status === 200){
        
          // Limpiar del state
          setState((prev) => ({
            ...prev,
            documents: {
              ...prev.documents,
              [tipo]: null,
            },
          }));
          showNotification("success", "Documento Eliminado", `El documento ${tipo} ha sido eliminado`, null, 4);
          setLoader({ ...loader, loading: false });
          setOpenModalAdjuntos(false);
        }else {

          setOpenModalAdjuntos(false);
          setLoader({ ...loader, loading: false });
          showNotification(
            "error",
            "Ups... Algo sucedió",
            "Error al eliminar el documento",
            null,
            4,
          );
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [openModalConfirmDeleteDocument, setOpenModalConfirmDeleteDocument] = useState(false);
  const [documentoAEliminar, setDocumentoAEliminar] = useState({
    tipo: "",
    id: null,
  });

  const confirmarEliminarDocumento = (tipo) => {
    const documento = state.documents[tipo];

    if (!documento) return;

    setDocumentoAEliminar({
      tipo,
      id: documento.id || null,
    });
    setOpenModalConfirmDeleteDocument(true);
  };

  const aceptarEliminarDocumento = () => {
    if (!documentoAEliminar.tipo) return;
    eliminarDocumento(documentoAEliminar.tipo);
    setOpenModalConfirmDeleteDocument(false);
    setDocumentoAEliminar({ tipo: "", id: null });
  };

  const cerrarConfirmacionEliminarDocumento = () => {
    setOpenModalConfirmDeleteDocument(false);
    setDocumentoAEliminar({ tipo: "", id: null });
  };

  const openModalCrearPeticion = async (data) => {
    setLoader({ ...loader, loading: true });
   
    const areas = await services({
      method: "GET",
      service: "areas/by-municipality",
      body: null,
    });
    if (areas.status === 200) {
      setState({
        ...state,
        citizenEditSelected: data,
        areas: areas.data,
      });
      setOpenModalPeticion(true);
      setLoader({ ...loader, loading: false });
    }
  };

  const openmodal = async (data) => {
      setState({ ...state, citizenEditSelected: data});
      setOpenModalEditar(true);
  };

  const openModalAñadir = async () => {
    setLoader({ ...loader, loading: true });
    const victims = await services({
      method: "GET",
      service: "victims/name",
      body: null,
    });

    if (victims.status === 200) {
      setState({
        ...state,
        citizens: victims.data,
      });
      setLoader({ ...loader, loading: false });
      setopenModal(true);
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...Algo sucedió",
        "Al cargar las solicitudes",
        null,
        4,
      );
    }
  };

  const openModalAdjuntar = async (application) => {

    setOpenModalAdjuntos(true);
    try {

      const response = await services({
        method: "GET",
        service: `/applications/${application.id}/documents`,
        body: null,
      });

      const documentos = {
        FUD: null,
        DENUNCIA: null,
        REVIM: null,
        DICTAMEN_ECONOMICO: null,
      };

      for (const doc of response.data || []) {
        const fileResponse = await services({
          method: "GET",
          service: `/documents/${doc.id}/download`,
          body: null,
          responseType: "blob",
        });

        documentos[doc.type] = {
          id: doc.id,
          original_name: doc.original_name,
          type: doc.type,
          url:
            fileResponse.status === 200
              ? URL.createObjectURL(fileResponse.data)
              : `${process.env.REACT_APP_URLAPI}/documents/${doc.id}/download`,
          existing: true,
        };
      }

      setState((prev) => ({
        ...prev,
        citizenEditSelected: application,
        documents: documentos,
      }));

    } catch (error) {
      console.log(error);
    }
  };

  const [totalSolicitudes, setTotalSolicitudes] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize] = useState(10);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const normalizePaginatedResponse = (payload) => {
    const source = payload?.data ?? payload ?? {};
    const rows = Array.isArray(source?.data)
      ? source.data
      : Array.isArray(source)
        ? source
        : [];
    const total = Number(source?.total ?? payload?.total ?? rows.length ?? 0);

    return { rows, total };
  };

  const getCitizensAndRequests = async (pageIndex = 0, rowsPerPage = 10, victimId = null, status_group=null, applicationId = null) => {
    if (buscar) {
      setBuscar(false);
      pageIndex = 0;
      setPage(0);
      setBuscador({ ...buscador, error: "" });
    }
    let url = `applications/?page=${pageIndex + 1}`;
    if (victimId) {
      url += `&victim_id=${victimId}`;
    }
    if (status_group) {
       url += `&status_group=${status_group}`;
    }
    if (applicationId) {
      url += `&application_id=${applicationId}`;
    }
    let requests = await services({
      method: "GET",
      service: url,
      body: null,
    });

    if (requests.status === 200) {
      const { rows, total } = normalizePaginatedResponse(requests.data);
      setState({
        ...state,
        requests: rows,
        openEditarCiudadano: false,
        openFiltro: false,
      });

      setTotalSolicitudes(total);

      setLoader({ ...loader, loading: false });

    } else {

      setLoader({ ...loader, loading: false });

      showNotification(
        "error",
        "Ups...Algo sucedió",
        "Al cargar las solicitudes",
        null,
        4,
      );
    }
  };

  const validarBuscador = async (pageIndex = 0) => {
    if (!buscador.texto) {
      const pagOriginal = 0;
      getCitizensAndRequests(pagOriginal);
      setBuscador({ ...buscador, error: "El campo no puede ir vacío" });
      setTimeout(() => {
        setBuscador({ ...buscador, error: "" });
      }, 3000);
    } else {
      // setExportarBandera(1);
      setLoader({ ...loader, loading: true });
      const body = {
        buscador: buscador.texto,
        cantidad: 10,
      };
      const request = await services({
        method: "POST",
        service: `solicitudes/buscarSolicitud?page=${pageIndex + 1}`,
        body,
      });

      if (request.status === 200) {
        const { rows, total } = normalizePaginatedResponse(request.data);
        setBuscar(true);
        setBuscador({ ...buscador, error: "" });
        setState({ ...state, requests: rows });
        setTotalSolicitudes(total);
        setLoader({ ...loader, loading: false });
        limpiarFiltros();
      } else if (request.status === 500) {
        setLoader({ ...loader, loading: false });
        setBuscador({
          ...buscador,
          error: "Ha ocurrido un error en el servidor",
        });
      } else {
        setLoader({ ...loader, loading: false });
        setBuscador({ ...buscador, error: request.data.message });
      }
    }
  };

  // const openModalFiltro = async () => {
  //   setLoader({ ...loader, loading: true });
  //   const fonts = await services({
  //     method: "GET",
  //     service: "catFuentesSolicitudes/listar",
  //     body: null,
  //   });
  //   if (fonts.status === 200) {
  //     setLoader({ ...loader, loading: false });
  //     setState({ ...state, openFiltro: true, fonts: fonts.data.data });
  //   } else {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "error",
  //       "Ups...Algo sucedió",
  //       "Al cargar las solicitudes",
  //       null,
  //       4,
  //     );
  //   }
  // };

  // const exportar = async () => {
  //   setLoader({ ...loader, loading: true });

  //   const body = {
  //     folio: filtroSolicitud.folio,
  //     ciudadano: filtroSolicitud.ciudadano,
  //     fecha: filtroSolicitud.fecha,
  //     estado: filtroSolicitud.estado,
  //     fuente_solicitud: filtroSolicitud.fuente_solicitud,
  //     numero_gira: filtroSolicitud.numero_gira,
  //     lugar_gira: filtroSolicitud.lugar_gira,
  //     buscador: buscador.texto,
  //     exportar: exportarBandera,
  //   };

  //   let response = await services(
  //     {
  //       method: "POST",
  //       service: `solicitudes/exportar`,
  //       body: body,
  //     },
  //     {
  //       responseType: "arraybuffer",
  //     },
  //   );
  //   if (response.status === 200) {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "success",
  //       "Éxito",
  //       "Se ha descargado su archivo",
  //       null,
  //       4,
  //     );
  //     const link = document.createElement("a");
  //     link.href = `data:application/octet-stream;base64,${response.data.archivo}`;
  //     link.download = "Solicitudes.xlsx";
  //     link.click();
  //   } else {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "error",
  //       "Ups...",
  //       "Ocurrió algo al descargar su archivo",
  //       null,
  //       4,
  //     );
  //   }
  // };

  const customOptions = {
    filter: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    serverSide: true,
    count: totalSolicitudes,
    page,
    rowsPerPage,
    onTableChange: async (action, tableState) => {
      if (action === "changePage") {
        setPage(tableState.page);
      }
      if (action === "changeRowsPerPage") {
        setRowsPerPage(tableState.rowsPerPage);
        setPage(0);
      }
    },
    rowsPerPageOptions: [],
    selectableRows: "none",
    textLabels: {
      body: {
        noMatch: "Lo sentimos, no hay coincidencias en la búsqueda",
        toolTip: "Clasificar",
        columnHeaderTooltip: (column) => `Clasificar por ${column.label}`,
      },
    },
  };

  // const openModalEditarCiudadano = async (data) => {
  //   setLoader({ ...loader, loading: true });
  //   const titulos = await services({
  //     method: "GET",
  //     service: `catTiposTitulos/listar`,
  //     body: null,
  //   });
  //   const cargos = await services({
  //     method: "GET",
  //     service: `catTipoCargos/listarCargos`,
  //     body: null,
  //   });
  //   const municipios = await services({
  //     method: "GET",
  //     service: `catMunicipios/listar`,
  //     body: null,
  //   });
  //   let ciudadano = await services({
  //     method: "POST",
  //     service: `ciudadanos/mostrar`,
  //     body: { id: data.ciudadano_id },
  //   });
  //   if (
  //     ciudadano.status === 200 &&
  //     titulos.status === 200 &&
  //     cargos.status === 200
  //   ) {
  //     setLoader({ ...loader, loading: false });
  //     setTitulos({ ...titulosState, data: titulos.data.data });
  //     setCargos({ ...cargosState, data: cargos.data.data });
  //     setState({
  //       ...state,
  //       ciudadano: ciudadano.data.data,
  //       openEditarCiudadano: true,
  //       municipios: municipios.data.data,
  //     });
  //   } else {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "error",
  //       "ups... Algo sucedió",
  //       "Error al obtener información",
  //       null,
  //       4,
  //     );
  //     handleCloseEditarCiudadano();
  //   }
  // };

  const openModalEliminar = (data) => {
    setState({ ...state, citizenEditSelected: data });
    setOpenModalEliminar(true);
  };

  // const handleChangeBuscador = (e) => {
  //   setBuscador({ ...buscador, texto: e.target.value });
  // };

  const [buscar, setBuscar] = useState(false);

  const columns = [
    {
      name: "folio",
      label: "N° VICTIMA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let folio = state.requests[dataIndex].folio;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "95px" }}
            >
              {folio}
            </div>
          );
        },
      },
    },
    {
      name: "fecha_creacion",
      label: "FECHA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const fecha = formatDisplayDate(
            state.requests[dataIndex]?.created_at,
          );
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "95px" }}
            >
              {fecha}
            </div>
          );
        },
      },
    },
    {
      name: "victim",
      label: "VÍCTIMA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let victim = `${state.requests[dataIndex].victim?.name} ${state.requests[dataIndex].victim?.first_lastname} ${state.requests[dataIndex].victim?.second_lastname ? state.requests[dataIndex].victim?.second_lastname : ""}`;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "95px" }}
            >
              {victim}
            </div>
          );
        },
      },
    },
    {
      name: "victim_type",
      label: "TIPO DE VÍCTIMA",
      options: {
        filter: true,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let tipo_victima = state.requests[dataIndex].victim?.victim_type;
          return (
            <div
              className=" d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {tipo_victima}
            </div>
          );
        },
      },
    },
    {
      name: "crime",
      label: "DELITO / VIOL. D.H.",
      options: {
        filter: true,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          const authority = state.requests[dataIndex]?.victim?.authority;
          const crimeDescription = formatAuthorityCrimes(authority);
          const isLongDescription = crimeDescription.length > 50;

          return (
            <div
              className={`d-flex align-items-center${isLongDescription ? " cursor-pointer" : ""}`}
              style={{ height: "60px" }}
              onClick={
                isLongDescription
                  ? () => openModalDescripcion(crimeDescription)
                  : undefined
              }
            >
              {isLongDescription
                ? `${crimeDescription.substring(0, 50)} ...`
                : crimeDescription}
            </div>
          );
        },
      },
    },
    {
      name: "phone",
      label: "CONTACTO",
      options: {
        filter: true,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let contacto = state.requests[dataIndex].victim?.phone;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {contacto}
            </div>
          );
        },
      },
    },
    {
      name: "municipio",
      label: "MUNICIPIO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let municipio = state.requests[dataIndex].victim?.municipality?.name;
          if (municipio !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {municipio}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "nuc",
      label: "NUC",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let nuc = state.requests[dataIndex].victim?.authority?.mp_nuc;
          if (nuc !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {nuc}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "ap/ci",
      label: "A.P./C.I.",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let ap_ci = state.requests[dataIndex].victim?.authority?.mp_file_type;
          if (ap_ci !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {ap_ci}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "exp",
      label: "NO. EXPEDIENTE",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let exp = state.requests[dataIndex].victim?.authority?.mp_exp;
          if (exp !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {exp}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "collective",
      label: "COLECTIVO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let collective = state.requests[dataIndex].collective;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "95px" }}
            >
              {collective}
            </div>
          );
        },
      },
    },
    {
      name: "OBSERVACIONES",
      label: "OBSERVACIONES",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const observations = state.requests[dataIndex].observations;
          if (observations) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center cursor-pointer"
                onClick={() => openModalDescripcion(observations)}
              >
                {observations.substring(0, 50)} ...
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    ...(isRegistro ? [
    {
      name: "REVIM",
      label: "REVIM",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let revim = state.requests[dataIndex].REVIM;
          if (revim !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {revim}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    ] : []),
    
    ...(isRegistro ? [
    {
      name: "RENAVI",
      label: "RENAVI",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let renavi = state.requests[dataIndex].RENAVI;
          if (renavi !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {renavi}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    ] : []),
    {
      name: "operaciones",
      label: "OPERACIONES",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex, i) => (
          <>
            <div
              style={{ height: "60px" }}
              className="text-decoration-underline d-flex align-items-center"
            >
              {!isRegistro && (
                <Tooltip title="VER PETICIONES/SERVICIOS">
                  <div
                    style={{ height: 30, width: 30, zIndex: 0 }}
                    className="cta cta--primary cta--icon icon_btn"
                    onClick={() => {
                    goTo(
                      `/peticionesVictimas/${state.requests[dataIndex].id}`,
                    );
                  }}
                >
                    <IconUI size={"20px"} color={"black"}>
                      <FaHandsHelping />
                    </IconUI>
                  </div>
                </Tooltip>
              )}
              {!isRegistro && (
                <Tooltip title="CREAR PETICIÓN/SERVICIO">
                  <div
                    style={{ height: 30, width: 30, zIndex: 0 }}
                    className="cta cta--primary cta--icon icon_btn"
                    onClick={() => {
                      openModalCrearPeticion(state.requests[dataIndex]);
                    }}
                  >
                    <IconUI size={"20px"} color={"black"}>
                      <FaFileSignature/>
                    </IconUI>
                  </div>
                </Tooltip>
              )}
              <Tooltip title="ADJUNTAR DOCUMENTOS">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    openModalAdjuntar(state.requests[dataIndex]);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <AiOutlineFolderOpen />
                  </IconUI>
                </div>
              </Tooltip>
              <Tooltip title="EDITAR SOLICITUD">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    openmodal(state.requests[dataIndex]);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <AiOutlineEdit />
                  </IconUI>
                </div>
              </Tooltip>
              {!isRegistro && !isPrimerContacto && (
                <Tooltip title="ELIMINAR SOLICITUD">
                  <div
                    style={{ height: 30, width: 30, zIndex: 0, marginLeft: 5 }}
                    className="cta cta--warning cta--icon icon_btn"
                    onClick={() => {
                      openModalEliminar(state.requests[dataIndex]);
                    }}
                  >
                    <IconUI size={"20px"} color={"black"}>
                      <AiOutlineDelete />
                    </IconUI>
                  </div>
                </Tooltip>
              )}
            </div>
          </>
        ),
      },
    },
  ];

  const validarFormulario = () => {
    let newErrors = {};
    if (!formularioState.victim_id) {
      newErrors.citizen = "Este Campo es requerido";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarEditar = () => {
    let newErrors = {};
    // if (isRegistro) {
    //   if (!state.citizenEditSelected.REVIM) {
    //     newErrors.REVIM = "Este Campo es requerido";
    //   }
    //   if (!state.citizenEditSelected.RENAVI) {
    //     newErrors.RENAVI = "Este Campo es requerido";
    //   }
    // }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const regexEmail = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,24}$/;

  const validarEditarCiudadano = () => {
    let newErrors = {};
    if (!state.ciudadano.nombre) {
      newErrors.nombre = "Este Campo es Requerido";
    }
    if (!state.ciudadano.apellido_paterno) {
      newErrors.apellidoPaterno = "Este Campo es Requerido";
    }
    if (state.ciudadano.tipo_persona === "") {
      newErrors.tipo = "Este Campo es Requerido";
    }
    if (
      state.ciudadano.ine !== null &&
      state.ciudadano.ine !== "" &&
      state.ciudadano.ine.length < 13
    ) {
      newErrors.ine = "Favor poner un número de identificación válido";
    }
    if (
      state.ciudadano.telefono !== null &&
      state.ciudadano.telefono.length < 10
    ) {
      newErrors.telefono = "Favor poner un número de 10 dígitos";
    }
    if (state.ciudadano.cp !== null && state.ciudadano.cp.length < 5) {
      newErrors.cp = "Favor poner un código postal válido";
    }

    if (state.ciudadano.email !== null && state.ciudadano.email !== "") {
      let valido = regexEmail.test(state.ciudadano.email);
      if (!valido) {
        newErrors.email = "Ingrese un email válido";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarFormularioPeticion = () => {
    let newErrors = {};
    if (!formularioPeticionState.area_id) {
      newErrors.area_id = "Este Campo es requerido";
    }
    if (!formularioPeticionState.priority) {
      newErrors.priority = "Este Campo es requerido";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const limpiarFormularioPeticion = () => {
    setFormularioPeticion({
      ...formularioPeticionState,
      subject: "",
      area_id: "",
      priority: "",
    });
  };

  const limpiarFormulario = () => {
    setFormulario({
      ...formularioState,
      collective: "",
      observations: "",
      victim_id: "",
    });
  };

  const createRequest = async () => {
    if (validarFormulario()) {
      setLoader({ ...loader, loading: true });
      const body = {
        collective: formularioState.collective,
        observations: formularioState.observations?.toUpperCase(),
        victim_id: formularioState.victim_id,
      };
      const request = await services({
        method: "POST",
        service: "applications",
        body,
      });
      if (request.status === 201) {

        getCitizensAndRequests(page);
        limpiarFormulario();
        setopenModal(false);
        setLoader({ ...loader, loading: false });
        showNotification(
          "success",
          "Solicitud Creada con Éxito",
          "Tu folio es:" + request.data.data.folio,
          null,
        );

      } else {
        setState({
          ...state,
          citizenSelected: "",
          numTour: "",
          nameTour: "",
          observations: "",
        });
        setopenModal(false);
        limpiarFormulario();
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Crear Solicitud",
          request.data.message,
          null,
          4,
        );
      }
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...",
        "Favor de llenar los campos",
        null,
        4,
      );
    }
  };

  const editRequest = async () => {
    if (validarEditar) {
      setLoader({ ...loader, loading: true });
      const editarSolicitud = await services({
        method: "PUT",
        service: `applications/${state.citizenEditSelected.id}`,
        body: {
          collective: state.citizenEditSelected.collective,
          observations: state.citizenEditSelected.observations?.toUpperCase(),
          REVIM: state.citizenEditSelected.REVIM?.toUpperCase(),
          RENAVI: state.citizenEditSelected.RENAVI?.toUpperCase(),
        },
      });
      if (editarSolicitud.status === 200) {

        setLoader({ ...loader, loading: false });

        getCitizensAndRequests(page, pageSize, victimId, status_group, applicationId);
        setOpenModalEditar(false);
        showNotification(
          "success",
          "Solicitud",
          "Se ha editado con Éxito",
          null,
          4,
        );

      } else {
        setLoader({ ...loader, loading: false });

        setOpenModalEditar(false);
        showNotification(
          "error",
          "Ups...",
          "Error al editar la solicitud",
          null,
          4,
        );
      }
    } else {
      showNotification(
        "error",
        "Ups...",
        "Error favor de llenar los campos",
        null,
        4,
      );
    }
  };

  const deleteRequest = async () => {
    setLoader({ ...state, loading: true });
    const eliminarSolicitud = await services({
      method: "DELETE",
      service: `applications/${state.citizenEditSelected.id}`,
      body: null,
    });
    if (eliminarSolicitud.status === 200) {

      setOpenModalEliminar(false);
      getCitizensAndRequests(page);
      showNotification("success", "Solicitud Eliminada con Éxito", "", null, 4);
      setLoader({ ...state, loading: false });

    } else if (eliminarSolicitud.status === 409) {
      setLoader({ ...state, loading: false });

      setOpenModalEliminar(false);
      showNotification(
        "error",
        "Ups...",
        "Error la solicitud seleccionada aun tiene Peticiones asignadas",
        null,
        4,
      );
    } else {
      setLoader({ ...state, loading: false });

      setOpenModalEliminar(false);
      showNotification(
        "error",
        "Ups...",
        "Error al Eliminar el Solicitud",
        null,
        4,
      );
    }
  };

  const crearPeticion = async () => {
    setLoader({ ...loader, loading: true });
    if (validarFormularioPeticion()) {
      const peticion = await services({
        method: "POST",
        service: "petitions",
        body: {
          application_id: state.citizenEditSelected.id,
          subject: formularioPeticionState.subject,
          area_id: formularioPeticionState.area_id,
          priority: formularioPeticionState.priority,
        },
      });
      if (peticion.status === 201) {

        showNotification("success", "Petición", "Creada con Éxito", null, 4);
        limpiarFormularioPeticion();

        // getCitizensAndRequests(page);
        setOpenModalPeticion(false);
        setLoader({ ...loader, loading: false });
        setPeticion(peticion.data.folio);
        goTo(`/solicitudesVictimas/solicitud/${state.citizenEditSelected.id}`);
      } else {

        setOpenModalPeticion(false);
        setLoader({ ...loader, loading: false });
        limpiarFormularioPeticion();
        showNotification(
          "error",
          "Ups... Algo sucedió",
          "Error al Crear Petición",
          null,
          4,
        );
      }
    } else {
      showNotification(
        "error",
        "Ups... ",
        "Por favor llena los campos marcados",
        null,
        4,
      );
      setLoader({ ...loader, loading: false });
    }
  };

  const editarCiudadano = async () => {
    setLoader({ ...loader, loading: true });
    if (validarEditarCiudadano()) {
      const ciudadano = await services({
        method: "POST",
        service: `ciudadanos/editar`,
        body: {
          id: state.ciudadano.id,
          cat_tipo_titulo_id: state.ciudadano.cat_tipo_titulo_id,
          nombre: state.ciudadano.nombre?.toUpperCase(),
          apellido_paterno: state.ciudadano.apellido_paterno?.toUpperCase(),
          apellido_materno: state.ciudadano.apellido_materno?.toUpperCase(),
          tipo_persona: state.ciudadano.tipo_persona,
          edad: state.ciudadano.edad,
          sexo: state.ciudadano.sexo,
          ine: state.ciudadano.ine.toUpperCase(),
          cat_tipo_cargo_id: state.ciudadano.cat_tipo_cargo_id,
          telefono: state.ciudadano.telefono,
          email: state.ciudadano.email?.toUpperCase(),

          calle: state.ciudadano.calle?.toUpperCase(),
          numero_ext: state.ciudadano.numero_ext?.toUpperCase(),
          colonia: state.ciudadano.colonia?.toUpperCase(),
          cp: state.ciudadano.cp,
          estado: state.ciudadano.estado,
          municipio_id: state.ciudadano.municipio_id,
          localidad_id: state.ciudadano.localidad_id,
        },
      });
      if (ciudadano.status === 200) {

        getCitizensAndRequests(page);
      } else {
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Ups... Algo Sucedió",
          ciudadano.data.message,
          null,
          4,
        );
        setState({ ...state, openModalEditar: false });
      }
    } else {
      setLoader({ ...loader, loading: false });
      showNotification("error", "Verifica", "Los campos marcados", null, 4);
    }
  };

  const handleCitizen = (e) => {
    setFormulario((formularioState) => ({
      ...formularioState,
      victim_id: e ? e.id : null,
    }));
  };

  const handleObservations = (e) => {
    setFormulario({ ...formularioState, observations: uppercaseText(e.target.value)});
  };

  const handleCollective = (e) => {
    setFormulario({ ...formularioState, collective: e.target.value });
  };
  const handleEditCollective = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        collective: e.target.value,
      },
    });
  };

  const limpiarCollective = () => {
    setFormulario((prev) => ({ ...prev, collective: "" }));
  };

  const limpiarEditCollective = () => {
    setState((prev) => ({
      ...prev,
      citizenEditSelected: {
        ...prev.citizenEditSelected,
        collective: "",
      },
    }));
  };

  const handleEditObservations = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        observations: uppercaseText(e.target.value),
      },
    });
  };

  const handleEditREVIM = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        REVIM: uppercaseText(e.target.value),
      },
    });
  };
    const handleEditRENAVI = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        RENAVI: uppercaseText(e.target.value),
      },
    });
  };
  const handleSubject = (e) => {
    setFormularioPeticion((formularioPeticionState) => ({
      ...formularioPeticionState,
      subject: uppercaseText(e.target.value),
    }));
  };
  const handlePriority = (e) => {
    setFormularioPeticion({
      ...formularioPeticionState,
      priority: e.target.value,
    });
  };
  const handleArea = (e) => {
    setFormularioPeticion((formularioPeticionState) => ({
      ...formularioPeticionState,
      area_id: e ? e.id : null,
    }));
  };


  // const handleChangeDate = (e) => {
  //   const selectedDate = dayjs(e.$d);
  //   setFormulario({
  //     ...formularioState,
  //     fecha_audiencia: selectedDate.format("YYYY-MM-DD"),
  //   });
  // };

  // const handleChangeFont = (e) => {
  //   setFormulario({ ...formularioState, fuente_solicitud_id: e.target.value });
  // };


  const handleClose = () => {

    setOpenModalEditar(false);
  };
  const handleCloseEditarCiudadano = () => {
    setState({ ...state, openEditarCiudadano: false });
  };

  const handleCloseEliminar = () => {

    setOpenModalEliminar(false);
  };

  const handleClosePeticion = () => {

    setOpenModalPeticion(false);
  };

  const handleCloseFiltro = () => {
    setState({ ...state, openFiltro: false });
  };

  const handleSeleccionadoTitulo = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, cat_tipo_titulo_id: e.target.value },
    });
  };
  const handleSeleccionadoNombre = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, nombre: e.target.value },
    });
  };
  const handleSeleccionadoApellidoPaterno = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, apellido_paterno: e.target.value },
    });
  };
  const handleSeleccionadoApellidoMaterno = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, apellido_materno: e.target.value },
    });
  };
  const handleSeleccionadoTipo = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, tipo_persona: e.target.value },
    });
  };
  const handleSeleccionadoSexo = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, sexo: e.target.value },
    });
  };
  const handleSeleccionadoIne = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, ine: e.target.value },
    });
  };
  const handleSeleccionadoCargo = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, cat_tipo_cargo_id: e ? e.id : null },
    });
  };
  const handleSeleccionadoTelefono = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, telefono: e.target.value },
    });
  };
  const handleSeleccionadoEmail = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, email: e.target.value },
    });
  };

  const handleSeleccionadoEdad = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, edad: e.target.value },
    });
  };
  const handleSeleccionadoCalle = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, calle: e.target.value },
    });
  };
  const handleSeleccionadoNumero = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, numero_ext: e.target.value },
    });
  };
  const handleSeleccionadoColonia = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, colonia: e.target.value },
    });
  };
  const handleSeleccionadoCp = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, cp: e.target.value },
    });
  };
  const handleSeleccionadoEstado = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, estado: e.target.value },
    });
  };
  const handleSeleccionadoMunicipio = async (e) => {
    let localidades = await services({
      method: "POST",
      service: `catLocalidades/listaPorMunicipio`,
      body: { municipio_id: e.target.value },
    });
    if (localidades.status === 200) {
      setState({
        ...state,
        localidades: localidades.data.data,
        ciudadano: { ...state.ciudadano, municipio_id: e.target.value },
      });
    } else {
      showNotification("error", "Ups...", localidades.data.message, null, 4);
    }
  };
  const handleSeleccionadoLocalidad = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, localidad_id: e.target.value },
    });
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (!buscar) {
        getCitizensAndRequests(page, pageSize, victimId, status_group, applicationId);
      } else {
        validarBuscador(page);
      }
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [page, pageSize, victimId, status_group, applicationId]);

  return (
    <>
      <div className=" justify-content-center align-items-start py-4">
        {loader.loading && <LoaderComponent />}
        <div className="container">
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Grid item xs={12} sm={12} md={6}>
              {/* <TextField
                sx={{
                  borderRadius: "30px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
                fullWidth
                size="small"
                id="busqueda"
                type="text"
                label="Buscar..."
                variant="outlined"
                value={buscador.texto}
                error={!!buscador.error}
                helperText={buscador.error || ""}
                onChange={handleChangeBuscador}
                InputProps={{
                  maxLength: 100,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setPage(0);
                          validarBuscador();
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              /> */}
            </Grid>

            <Grid item>
              {/* <ColorButton
                startIcon={<SearchIcon />}
                className="me-3"
                onClick={openModalFiltro}
              >
                Filtro
              </ColorButton> */}
              {/* <ColorButton
                startIcon={<RiFileExcel2Line />}
                className="me-3"
                onClick={exportar}
              >
                exportar
              </ColorButton> */}
              {!isRegistro && (
                <ColorButton
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={() => {
                    openModalAñadir();
                  }}
                >
                  Añadir Solicitud
                </ColorButton>
              )}
            </Grid>
          </Grid>
        </div>
        <Box sx={{ flexGrow: 2 }}>
          <Grid className="container mt-3 mb-3" maxWidth="xl">
            <ThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                data={state.requests}
                title={`TABLA DE SOLICITUDES`}
                columns={columns}
                options={customOptions}
              />
            </ThemeProvider>
          </Grid>
        </Box>

        <ModalText
          open={state.openDescripcion}
          onClose={handleCloseDescripcion}
          descripcion={state.descripcion}
        />

        <Modal
          open={state.openEditarCiudadano}
          onClose={handleCloseEditarCiudadano}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style2}>
            <h3 className="TitulosProgramas">EDITAR CIUDADANO</h3>
            <hr />
            <h5>DATOS GENERALES</h5>
            <hr />
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Titulo"
                  label="TITULO"
                  variant="outlined"
                  select
                  error={!!errors.titulo}
                  helperText={errors.titulo || ""}
                  onChange={handleSeleccionadoTitulo}
                  value={state.ciudadano.cat_tipo_titulo_id}
                >
                  {/* {titulosState.data &&
                    titulosState.data.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.tipo_titulo}
                      </MenuItem>
                    ))} */}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="NOMBRE"
                  variant="outlined"
                  error={!!errors.nombre}
                  helperText={errors.nombre || ""}
                  value={state.ciudadano.nombre}
                  onChange={handleSeleccionadoNombre}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-apellidoP"
                  label="APELLIDO PATERNO"
                  variant="outlined"
                  error={!!errors.apellidoPaterno}
                  helperText={errors.apellidoPaterno || ""}
                  value={state.ciudadano.apellido_paterno}
                  onChange={handleSeleccionadoApellidoPaterno}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-apellidoM"
                  label="APELLIDO MATERNO"
                  variant="outlined"
                  error={!!errors.apellidoMaterno}
                  helperText={errors.apellidoMaterno || ""}
                  value={state.ciudadano.apellido_materno}
                  onChange={handleSeleccionadoApellidoMaterno}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-TipoUsuario"
                  label="TIPO"
                  variant="outlined"
                  select
                  error={!!errors.tipo}
                  helperText={errors.tipo || ""}
                  onChange={handleSeleccionadoTipo}
                  value={state.ciudadano.tipo_persona}
                >
                  <MenuItem value={1}>CIUDADANO</MenuItem>
                  <MenuItem value={0}>ASOCIACIÓN CIVIL</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-INE"
                  label="EDAD"
                  variant="outlined"
                  error={!!errors.edad}
                  helperText={errors.edad || ""}
                  onChange={handleSeleccionadoEdad}
                  value={state.ciudadano.edad}
                  inputProps={{ maxLength: 2 }}
                  onKeyPress={onlyNumber}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-TipoUsuario"
                  label="GÉNERO"
                  variant="outlined"
                  select
                  error={!!errors.genero}
                  helperText={errors.genero || ""}
                  onChange={handleSeleccionadoSexo}
                  value={state.ciudadano.sexo}
                >
                  <MenuItem value={"MASCULINO"}>MASCULINO</MenuItem>
                  <MenuItem value={"FEMENINO"}>FEMENINO</MenuItem>
                  <MenuItem value={"LGTBIQA+"}>LGTBIQA+</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-INE"
                  label="INE"
                  variant="outlined"
                  error={!!errors.ine}
                  helperText={errors.ine || ""}
                  onChange={handleSeleccionadoIne}
                  value={state.ciudadano.ine}
                  inputProps={{ maxLength: 13 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  // options={cargosState.data || []}
                  getOptionLabel={(option) => option.tipo_cargo}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px",
                  }}
                  // value={
                  //   cargosState.data.find(
                  //     (option) =>
                  //       option.id === state.ciudadano.cat_tipo_cargo_id,
                  //   ) || null
                  // }
                  onChange={(event, newValue) =>
                    handleSeleccionadoCargo(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="CARGO"
                      error={!!errors.cargo}
                      helperText={errors.cargo || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-telefono"
                  label="TELÉFONO"
                  variant="outlined"
                  error={!!errors.telefono}
                  helperText={errors.telefono || ""}
                  onChange={handleSeleccionadoTelefono}
                  value={
                    state.ciudadano.telefono !== null
                      ? state.ciudadano.telefono
                      : ""
                  }
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-correo"
                  label="CORREO"
                  variant="outlined"
                  value={
                    state.ciudadano.email !== null ? state.ciudadano.email : ""
                  }
                  error={errors.email}
                  helperText={errors.email || ""}
                  onChange={handleSeleccionadoEmail}
                  onKeyPress={(event) => {
                    maxLengthLimitInput(event, 55, "email");
                  }}
                />
              </Grid>
              <hr />
              <hr />
              <h5 className="ms-4 mt-3">DIRECCIÓN</h5>
              <hr />
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-calle"
                  label="CALLE"
                  variant="outlined"
                  error={errors.calle}
                  helperText={errors.calle || ""}
                  value={state.ciudadano.calle}
                  onChange={handleSeleccionadoCalle}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-numero"
                  label="NUMERO"
                  variant="outlined"
                  error={errors.numero}
                  helperText={errors.numero || ""}
                  value={state.ciudadano.numero_ext}
                  onChange={handleSeleccionadoNumero}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-colonia"
                  label="COLONIA"
                  variant="outlined"
                  error={errors.colonia}
                  helperText={errors.colonia || ""}
                  value={state.ciudadano.colonia}
                  onChange={handleSeleccionadoColonia}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-cp"
                  label="C.P."
                  variant="outlined"
                  error={errors.cp}
                  helperText={errors.cp || ""}
                  value={state.ciudadano.cp !== null ? state.ciudadano.cp : ""}
                  onChange={handleSeleccionadoCp}
                  inputProps={{ maxLength: 5 }}
                  onKeyPress={onlyNumber}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-localidad"
                  label="ENTIDAD FEDERATIVA"
                  variant="outlined"
                  select
                  error={errors.estado}
                  helperText={errors.estado || ""}
                  value={state.ciudadano.estado}
                  onChange={handleSeleccionadoEstado}
                >
                  <MenuItem value={"AGUASCALIENTES"}>AGUASCALIENTES</MenuItem>
                  <MenuItem value={"BAJA CALIFORNIA"}>BAJA CALIFORNIA</MenuItem>
                  <MenuItem value={"BAJA CALIFORNIA SUR"}>
                    BAJA CALIFORNIA SUR
                  </MenuItem>
                  <MenuItem value={"CAMPECHE"}>CAMPECHE</MenuItem>
                  <MenuItem value={"CHIAPAS"}>CHIAPAS</MenuItem>
                  <MenuItem value={"CHIHUAHUA"}>CHIHUAHUA</MenuItem>
                  <MenuItem value={"CIUDAD DE MÉXICO"}>
                    CIUDAD DE MÉXICO
                  </MenuItem>
                  <MenuItem value={"COAHUILA DE ZARAGOZA"}>
                    COAHUILA DE ZARAGOZA
                  </MenuItem>
                  <MenuItem value={"COLIMA"}>COLIMA</MenuItem>
                  <MenuItem value={"DURANGO"}>DURANGO</MenuItem>
                  <MenuItem value={"GUANAJUATO"}>GUANAJUATO</MenuItem>
                  <MenuItem value={"GUERRERO"}>GUERRERO</MenuItem>
                  <MenuItem value={"HIDALGO"}>HIDALGO</MenuItem>
                  <MenuItem value={"JALISCO"}>JALISCO</MenuItem>
                  <MenuItem value={"ESTADO DE MÉXICO"}>
                    ESTADO DE MÉXICO
                  </MenuItem>
                  <MenuItem value={"MICHOACÁN"}>MICHOACÁN</MenuItem>
                  <MenuItem value={"MORELOS"}>MORELOS</MenuItem>
                  <MenuItem value={"NAYARIT"}>NAYARIT</MenuItem>
                  <MenuItem value={"NUEVO LEÓN"}>NUEVO LEÓN</MenuItem>
                  <MenuItem value={"OAXACA"}>OAXACA</MenuItem>
                  <MenuItem value={"PUEBLA"}>PUEBLA</MenuItem>
                  <MenuItem value={"QUERÉTARO"}>QUERÉTARO</MenuItem>
                  <MenuItem value={"QUINTANA ROO"}>QUINTANA ROO</MenuItem>
                  <MenuItem value={"SAN LUIS POTOSÍ"}>SAN LUIS POTOSÍ</MenuItem>
                  <MenuItem value={"SINALOA"}>SINALOA</MenuItem>
                  <MenuItem value={"SONORA"}>SONORA</MenuItem>
                  <MenuItem value={"TABASCO"}>TABASCO</MenuItem>
                  <MenuItem value={"TAMAULIPAS"}>TAMAULIPAS</MenuItem>
                  <MenuItem value={"TLAXCALA"}>TLAXCALA</MenuItem>
                  <MenuItem value={"VERACRUZ"}>VERACRUZ</MenuItem>
                  <MenuItem value={"YUCATÁN"}>YUCATÁN</MenuItem>
                  <MenuItem value={"ZACATECAS"}>ZACATECAS</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Titulo"
                  label="MUNICIPIO"
                  variant="outlined"
                  select
                  error={!!errors.municipio}
                  helperText={errors.municipio || ""}
                  onChange={handleSeleccionadoMunicipio}
                  value={state.ciudadano.municipio_id}
                >
                  {state.municipios &&
                    state.municipios.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.municipio}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Titulo"
                  label="LOCALIDAD"
                  variant="outlined"
                  select
                  error={!!errors.localidad}
                  helperText={errors.localidad || ""}
                  onChange={handleSeleccionadoLocalidad}
                  value={state.ciudadano.localidad_id}
                >
                  {state.localidades.length > 0 ? (
                    state.localidades.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.localidad}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem key={0} value={null}>
                      SIN LOCALIDADES
                    </MenuItem>
                  )}
                </TextField>
              </Grid>

              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    editarCiudadano();
                  }}
                >
                  EDITAR
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openModal}
          onClose={() => setopenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">CREAR SOLICITUD</h3>
            <Grid container columns={12} spacing={3}>
              
              <Grid item xs={12}>
                <Autocomplete
                  options={state.citizens || []}
                  getOptionLabel={(option) =>
                    option.full_name
                  }
                  fullWidth
                  size="small"
                  id="victim_id"
                  sx={{ borderRadius: "30px" }}
                  value={
                    state.citizens.find(
                      (option) => option.id === formularioState.victim_id,
                    ) || null
                  }
                  onChange={(event, newValue) => handleCitizen(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      label="NOMBRE DE LA VICTIMA"
                      error={!!errors.citizen}
                      helperText={errors.citizen || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ position: "relative" }}>
                  <TextField
                    sx={{
                      borderRadius: "30px",
                      "& .MuiSelect-select": { paddingRight: "64px !important" },
                    }}
                    fullWidth
                    size="small"
                    id="collective"
                    label="COLECTIVO"
                    variant="outlined"
                    select
                    error={!!errors.collective}
                    helperText={errors.collective || ""}
                    value={formularioState.collective}
                    onChange={handleCollective}
                  >
                    <MenuItem value={"EN TU BÚSQUEDA MICHOACÁN"}>EN TU BÚSQUEDA MICHOACÁN</MenuItem>
                    <MenuItem value={"BUSCANDO TUS PASOS"}>BUSCANDO TUS PASOS</MenuItem>
                    <MenuItem value={"DECOFEM"}>DECOFEM</MenuItem>
                    <MenuItem value={"CODEMICH"}>CODEMICH</MenuItem>
                    <MenuItem value={"SOMOS LA VOZ DE LOS DESAPARECIDOS MICHOACÁN"}>SOMOS LA VOZ DE LOS DESAPARECIDOS MICHOACÁN</MenuItem>
                    <MenuItem value={"FAMILIARES EN TU BÚSQUEDA MICHOACÁN"}>FAMILIARES EN TU BÚSQUEDA MICHOACÁN</MenuItem>
                    <MenuItem value={"HUELLAS MICHOACÁN"}>HUELLAS MICHOACÁN</MenuItem>
                    <MenuItem value={"BUSCANDO CUERPOS EN TODO MÉXICO"}>BUSCANDO CUERPOS EN TODO MÉXICO</MenuItem>

                  </TextField>
                  {formularioState.collective && (
                    <IconButton
                      aria-label="Limpiar colectivo"
                      title="Limpiar colectivo"
                      size="small"
                      onMouseDown={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        limpiarCollective();
                      }}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: 32,
                        transform: "translateY(-50%)",
                        zIndex: 1,
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="OBSERVACIONES"
                  multiline
                  rows={3}
                  value={formularioState.observations}
                  error={!!errors.observations}
                  helperText={errors.observations || ""}
                  onChange={handleObservations}
                />
              </Grid>

              <Grid marginLeft="auto" item>
                <ColorButton onClick={createRequest}>Crear</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openModalEditar}
          onClose={() => handleClose()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">EDITAR SOLICITUD</h3>
            <Grid container columns={12} spacing={3}>
              {!isRegistro && (
                <Grid item xs={12}>
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      sx={{
                        borderRadius: "30px",
                        "& .MuiSelect-select": { paddingRight: "64px !important" },
                      }}
                      fullWidth
                      size="small"
                      id="collective-edit"
                      label="COLECTIVO"
                      variant="outlined"
                      select
                      error={!!errors.collective}
                      helperText={errors.collective || ""}
                      value={state.citizenEditSelected.collective || ""}
                      onChange={handleEditCollective}
                    >
                      <MenuItem value={"EN TU BÚSQUEDA MICHOACÁN"}>EN TU BÚSQUEDA MICHOACÁN</MenuItem>
                      <MenuItem value={"BUSCANDO TUS PASOS"}>BUSCANDO TUS PASOS</MenuItem>
                      <MenuItem value={"DECOFEM"}>DECOFEM</MenuItem>
                      <MenuItem value={"CODEMICH"}>CODEMICH</MenuItem>
                      <MenuItem value={"SOMOS LA VOZ DE LOS DESAPARECIDOS MICHOACÁN"}>SOMOS LA VOZ DE LOS DESAPARECIDOS MICHOACÁN</MenuItem>
                      <MenuItem value={"FAMILIARES EN TU BÚSQUEDA MICHOACÁN"}>FAMILIARES EN TU BÚSQUEDA MICHOACÁN</MenuItem>
                      <MenuItem value={"HUELLAS MICHOACÁN"}>HUELLAS MICHOACÁN</MenuItem>
                      <MenuItem value={"BUSCANDO CUERPOS EN TODO MÉXICO"}>BUSCANDO CUERPOS EN TODO MÉXICO</MenuItem>
                    </TextField>
                    {state.citizenEditSelected.collective && (
                      <IconButton
                        aria-label="Limpiar colectivo"
                        title="Limpiar colectivo"
                        size="small"
                        onMouseDown={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          limpiarEditCollective();
                        }}
                        sx={{
                          position: "absolute",
                          top: "50%",
                          right: 32,
                          transform: "translateY(-50%)",
                          zIndex: 1,
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )}
                  </Box>
                </Grid>
              )}
              {!isRegistro && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="OBSERVACIONES"
                    multiline
                    rows={3}
                    value={state.citizenEditSelected.observations}
                    error={!!errors.observations}
                    helperText={errors.observations || ""}
                    onChange={handleEditObservations}
                  />
                </Grid>
              )}
              {isRegistro && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="REVIM"
                    value={state.citizenEditSelected.REVIM}
                    error={!!errors.REVIM}
                    helperText={errors.REVIM || ""}
                    onChange={handleEditREVIM}
                    inputProps={{ maxLength: 7 }}
                  />
                </Grid>
              )}
              {isRegistro && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="RENAVI"
                    value={state.citizenEditSelected.RENAVI}
                    error={!!errors.RENAVI}
                    helperText={errors.RENAVI || ""}
                    onChange={handleEditRENAVI}
                    inputProps={{ maxLength: 10 }}
                  />
                </Grid>
              )}
              <Grid marginLeft="auto" item>
                <ColorButton onClick={editRequest}>Editar</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openModalEliminarState}
          onClose={handleCloseEliminar}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs text-center" sx={style}>
            <h3 className="TitulosProgramas mb-3">
              ¿ESTÁ SEGURO DE ELIMINAR LA SOLICITUD CON FOLIO?
            </h3>

            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <h4>{state.citizenEditSelected.folio}</h4>
              </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    deleteRequest();
                  }}
                >
                  Eliminar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openModalPeticion}
          onClose={() => handleClosePeticion()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">CREAR PETICIÓN</h3>
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-subject"
                  label="PETICIÓN"
                  variant="outlined"
                  error={!!errors.subject}
                  helperText={errors.subject || ""}
                  value={formularioPeticionState.subject}
                  onChange={handleSubject}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={state.areas || []}
                  getOptionLabel={(option) => option.name}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px",
                  }}
                  value={
                    state.areas.find(
                      (option) =>
                        option.id === formularioPeticionState.area_id,
                    ) || null
                  }
                  onChange={(event, newValue) => handleArea(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      label="AREA"
                      error={!!errors.area_id}
                      helperText={errors.area_id || ""}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="priority"
                  label="PRIORIDAD"
                  variant="outlined"
                  select
                  error={!!errors.priority}
                  helperText={errors.priority || ""}
                  onChange={handlePriority}
                  value={formularioPeticionState.priority}
                >
                  <MenuItem value="ORDINARIO">ORDINARIO</MenuItem>
                  <MenuItem value="URGENTE">URGENTE</MenuItem>
                  <MenuItem value="URGENTE_TERMINO">URGENTE CON TERMINO</MenuItem>
                </TextField>
              </Grid>

              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    crearPeticion();
                  }}
                >
                  Guardar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openModalConfirmDeleteDocument}
          onClose={cerrarConfirmacionEliminarDocumento}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs text-center" sx={style}>
            <h3 className="TitulosProgramas mb-3">
              ¿ESTÁ SEGURO DE ELIMINAR EL DOCUMENTO?
            </h3>

            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <h4>{documentoAEliminar.tipo}</h4>
              </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton
                  className="me-2"
                  onClick={cerrarConfirmacionEliminarDocumento}
                >
                  Cancelar
                </ColorButton>
                <ColorButton
                  onClick={aceptarEliminarDocumento}
                >
                  Eliminar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openModalAdjuntos}
          onClose={() => setOpenModalAdjuntos(false)}          
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas mb-4">
              DOCUMENTOS ADJUNTOS
            </h3>

            <Grid container spacing={3}>
              {tiposDocumentosPermitidos.map((tipo) => (
                <Grid item xs={12} md={6} key={tipo}>
                  <Box
                    sx={{
                      border: "1px solid #dcdcdc",
                      borderRadius: "10px",
                      padding: "15px",
                    }}
                  >
                    <h4 style={{ marginBottom: "15px" }}>
                      {tipo}
                    </h4>

                    {(!isRegistro || !['FUD', 'DENUNCIA'].includes(tipo)) && (
                      <>
                        <input
                          accept="application/pdf"
                          style={{ display: "none" }}
                          id={`file-upload-${tipo}`}
                          type="file"
                          onChange={(e) =>
                            handleFileChange(tipo, e)
                          }
                        />

                        <label htmlFor={`file-upload-${tipo}`}>
                          <Button
                            variant="contained"
                            component="span"
                          >
                            Subir archivo
                          </Button>
                        </label>
                      </>
                    )}

                   
                   {state.documents[tipo] && (
                      <Box mt={2}>
                        <Typography variant="body2">

                          {state.documents[tipo].existing
                            ? state.documents[tipo].original_name
                            : state.documents[tipo].file.name}

                        </Typography>

                        <Box
                          component="button"
                          type="button"
                          onClick={() => abrirVistaPreviaDocumento(state.documents[tipo])}
                          sx={{
                            width: "100%",
                            border: "none",
                            background: "transparent",
                            padding: 0,
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                        >
                          {state.documents[tipo].existing ? (
                            <iframe
                              src={state.documents[tipo].url}
                              width="100%"
                              height="250px"
                              title={tipo}
                              style={{ pointerEvents: "none" }}
                            />
                          ) : state.documents[tipo].file.type === "application/pdf" ? (
                            <iframe
                              src={state.documents[tipo].preview}
                              width="100%"
                              height="250px"
                              title={tipo}
                              style={{ pointerEvents: "none" }}
                            />
                          ) : (
                            <img
                              src={state.documents[tipo].preview}
                              alt={tipo}
                              style={{
                                width: "100%",
                                maxHeight: "250px",
                                objectFit: "contain",
                              }}
                            />
                          )}
                        </Box>

                        {(!isRegistro || !['FUD', 'DENUNCIA'].includes(tipo)) && (
                          <Button
                            color="error"
                            variant="outlined"
                            sx={{ mt: 1 }}
                            onClick={() => confirmarEliminarDocumento(tipo)}
                          >
                            Eliminar
                          </Button>
                        )}
                      </Box>
                    )}
                  </Box>
                </Grid>
              ))}

              {/* BOTON ENVIAR */}
              <Grid item xs={12} textAlign="right">
                <ColorButton
                  onClick={() => enviarArchivos()}
                >
                  Enviar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={state.openPreviewDocumento}
          onClose={cerrarPreviewDocumento}
          aria-labelledby="preview-documento-title"
          aria-describedby="preview-documento-description"
        >
          <Box className="contenedorModalUrs" sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 1000,
            height: "85vh",
            bgcolor: "background.paper",
            border: "2px solid #661d40",
            boxShadow: 24,
            p: 4,
            borderRadius: "40px",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <h3 className="TitulosProgramas mb-0">
                  {state.previewDocumentoNombre || "Vista previa"}
                </h3>
              </Grid>
              <Grid item>
                <ColorButton onClick={cerrarPreviewDocumento}>Cerrar</ColorButton>
              </Grid>
            </Grid>

            {state.previewDocumentoUrl ? (
              state.previewDocumentoMime?.includes("pdf") ? (
                <iframe
                  title="preview-documento"
                  src={state.previewDocumentoUrl}
                  style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "500px",
                    border: "none",
                    borderRadius: "12px",
                  }}
                />
              ) : state.previewDocumentoMime?.startsWith("image/") ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                  <img
                    src={state.previewDocumentoUrl}
                    alt={state.previewDocumentoNombre}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                      borderRadius: "12px",
                    }}
                  />
                </Box>
              ) : (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                  <a href={state.previewDocumentoUrl} target="_blank" rel="noreferrer">
                    Abrir archivo en nueva ventana
                  </a>
                </Box>
              )
            ) : (
              <p>No hay vista previa disponible.</p>
            )}
          </Box>
        </Modal>

        <Modal
          open={state.openFiltro}
          onClose={() => handleCloseFiltro()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style3}>
            <h3 className="TitulosProgramas">Filtro</h3>
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="FOLIO"
                  value={filtroSolicitud.folio}
                  error={!!errors.folio}
                  helperText={errors.folio || ""}
                  onChange={handleFiltroFolio}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="CIUDADANO"
                  value={filtroSolicitud.ciudadano}
                  error={!!errors.ciudadano}
                  helperText={errors.ciudadano || ""}
                  onChange={handleFiltroCiudadano}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  select
                  label="ESTADO"
                  value={filtroSolicitud.estado}
                  error={!!errors.estado}
                  helperText={errors.estado || ""}
                  onChange={handleFiltroEstado}
                >
                  <MenuItem value={"NUEVO INGRESO"}>NUEVO INGRESO</MenuItem>
                  <MenuItem value={"INICIADA"}>INICIADA</MenuItem>
                  <MenuItem value={"ATENDIDA"}>ATENDIDA</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <LocalizationProvider
                  adapterLocale="es"
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="FECHA"
                    slotProps={{ textField: { size: "small" } }}
                    sx={{ width: 1 }}

                    format="DD/MM/YYYY"
                    views={["year", "month", "day"]}
                    onChange={handleFiltroFecha}
                    value={filtroSolicitud.fecha}

                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Fuentes"
                  label="FUENTES"
                  variant="outlined"
                  select
                  error={!!errors.font}
                  helperText={errors.font || ""}
                  onChange={handleFiltroFuente}
                  value={filtroSolicitud.fuente_solicitud}
                >
                  {state.fonts.map((item) => (
                    <MenuItem key={item.id} value={item.fuente_solicitud}>
                      {item.fuente_solicitud}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="NÚMERO DE GIRA"
                  value={filtroSolicitud.numero_gira}
                  error={!!errors.numero_gira}
                  helperText={errors.numero_gira || ""}
                  onChange={handleFiltroNumero}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="LUGAR DE GIRA"
                  value={filtroSolicitud.lugar_gira}
                  error={!!errors.lugar_gira}
                  helperText={errors.lugar_gira || ""}
                  onChange={handleFiltroLugar}
                />
              </Grid>
              <Grid marginLeft="auto" marginBottom={2} marginTop={2} item>
                <ColorButton
                  className="me-2"
                  onClick={() => {
                    limpiarFiltros();
                  }}
                >
                  LIMPIAR
                </ColorButton>
                <ColorButton
                  onClick={() => {
                    // setExportarBandera(2);
                    getCitizensAndRequests();
                  }}
                >
                  BUSCAR
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default SolicitudesVictimasView;
